module.exports = __webpack_public_path__ + "img/ch23_01_寻回兽降临.18ed312e.jpg";